import {
  IAugmentedJQuery,
  IComponentOptions,
  IController,
  IDocumentService,
  IFilterFilter,
  INgModelController,
  IPromise,
  IScope,
  ITimeoutService
} from 'angular';
import './gmc-select-3.component.scss';
import { checkInsideClick } from '../../../helpers/check-inside-click';

export class GmcSelect3Controller implements IController {
  static $inject = [
    '$scope',
    '$element',
    '$document',
    '$timeout',
    'filterFilter'
  ];
  onOpen: () => IPromise<any>;
  value: string;
  isActive = false;
  maxHeight = 180;
  placeholder = 'Select';
  _options: string[] = [];
  noOptions = 'No options';
  position = 'right';
  loading = false;
  filter = false;
  other: boolean = false;
  filterTerm: string;
  onSelect: (obj: any) => void;
  copyOptions: string[] = [];
  disabled: boolean;
  canInput: boolean = false;
  currency: boolean;
  pattern: RegExp;

  protected ngModel: INgModelController;

  constructor(
    private $scope: IScope,
    private $element: IAugmentedJQuery,
    private $document: IDocumentService,
    private $timeout: ITimeoutService,
    private filterFilter: IFilterFilter
  ) {
    this.documentClickListener = this.documentClickListener.bind(this);
  }

  $onInit() {
    this.initOutsideClickListener();
    if (this.currency) {
      this.pattern = new RegExp(
        '^[a-zA-Z\s-]*$'
      );
    }
  }

  $onChanges() {}

  set options(options: string[]) {
    this._options = options || [];
    this.copyOptions = this._options;
  }

  $postLink() {
    this.ngModel.$formatters.push((value) => {
      return value;
    });
    this.ngModel.$parsers.push((value) => {
      return value;
    });

    this.ngModel.$render = () => {
      this.value = this.ngModel.$viewValue;
    };
  }

  $onDestroy() {
    this.$document.off('click', this.documentClickListener);
  }

  onFocus() {
    this.isActive = true;
    this.emitOpened();
  }

  toggle(event) {
    event.preventDefault();
    if (this.isActive) {
      this.close();
    } else {
      this.isActive = true;
      this.emitOpened();
    }
  }

  filterOptions() {
    this.copyOptions = this.filterFilter(this._options, this.filterTerm);
  }

  selectOption(event, option: string) {
    event.preventDefault();
    if (option === 'Other' || option === 'Other...') {
      return this.selectOther();
    }
    this.ngModel.$setViewValue(option);
    this.value = option;
    this.canInput = false;
    this.placeholder = 'Select';
    this.onSelect({});
    this.close();
  }

  selectOther() {
    this.canInput = true;
    this.value = '';
    this.ngModel.$setViewValue(this.value);
    this.placeholder = 'Input other value';
    this.onSelect({});
    this.$element.find('.gmc-select3__select-input').focus();
  }

  onInput() {
    this.ngModel.$setViewValue(this.value);
  }

  reset() {
    this.value = this._options[0];
    this.ngModel.$setViewValue(this.value);
    this.canInput = false;
    this.placeholder = 'Select';
  }

  private emitOpened() {
    const cb = this.onOpen();
    if (cb && typeof cb.then === 'function') {
      this.loading = true;
      cb.then((data = []) => {
        this.loading = false;
        this.options = data;
        this.focusSearch();
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    } else {
      this.focusSearch();
    }
  }

  private close() {
    if (this.value === '') {
      this.reset();
    }
    this.isActive = false;
    this.filterTerm = '';
    this.options = this._options;
  }

  private documentClickListener(event) {
    if (!this.isActive) {
      return;
    }
    if (!checkInsideClick(this.$element[0], event)) {
      this.$scope.$apply(() => {
        this.close();
      });
    }
  }

  private initOutsideClickListener() {
    this.$document.on('click', this.documentClickListener);
  }

  private focusSearch() {
    this.$timeout(() => {
      if (!this.canInput) {
        this.$element.find('.gmc-select3__search-input').focus();
      }
    }, 100);
  }
}

export const GmcSelect3Component: IComponentOptions = {
  controller: GmcSelect3Controller,
  require: {
    ngModel: 'ngModel'
  },
  template: require('./gmc-select-3.component.html'),
  bindings: {
    options: '<',
    disabled: '<',
    currency: '<?',
    placeholder: '@?',
    maxHeight: '@?',
    noOptions: '@?',
    position: '@?',
    onSelect: '&',
    onOpen: '&',
    filter: '<?',
    other: '<?',
    inputName: '<?'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-select-3/gmc-select-3.component.ts